import Layout from '@/layout/index.vue'

export const evaluationMap = {
  path: '/evaluation',
  component: Layout,
  meta: { title: '测评', code: 655799 },
  children: [
    {
      path: 'evaluation',
      component: () => import('@/views/evaluation/evaluation/index.vue'),
      meta: { title: '测评管理', drop: true, code: 776943 },
      children: [
        {
          path: 'evaluation',
          meta: { title: '测评记录', code: 592958 },
          component: () => import('@/views/evaluation/evaluation/record/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/evaluation/evaluation/record/list.vue'),
              meta: { title: '测评记录', keepAlive: true }
            }
          ]
        },
        {
          path: 'advice',
          meta: { title: '运动建议', code: 718971 },
          component: () => import('@/views/evaluation/evaluation/advice/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/evaluation/evaluation/advice/list.vue'),
              meta: { title: '运动建议', keepAlive: true }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/evaluation/evaluation/advice/detail.vue'),
              meta: { title: '建议详情' }
            }
          ]
        }
      ]
    }
  ]
}
